
if (!customElements.get('theme-footer')) {
  class ThemeFooter extends HTMLElement {
    constructor() {
      super();
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.accordions = this.querySelectorAll('details');

      this.onResize();

      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    onResize() {
      const isDesktop = window.innerWidth >= 768;
      if (this._wasDesktop === isDesktop) return;
      this._wasDesktop = isDesktop;

      this.accordions.forEach((accordion) => {
        if (isDesktop) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('theme-footer', ThemeFooter);
}
